export namespace ConfirmationLetterData {
  export interface SubmitData {
    reason: string
  }
}
